import { FeatureButtonType } from "@habity/types";

export const FEATURES: FeatureButtonType[] = [
  {
    title: "Nyproduktion",
    key: "new_construction",
    description: "Detta är en nyproducerad bostad.",
    hidden: true,
  },
  {
    title: "Pool",
    key: "pool",
    description: "Bostaden har en swimmingpool.",
    // hidden: true,
  },
  {
    title: "Sjönära",
    key: "near_lake",
    description: "Bostaden har nära till insjö eller vattendrag.",
    // hidden: true,
  },
  {
    title: "Havsnära",
    key: "near_sea",
    description: "Bostaden har nära till kust eller hav.",
    // hidden: true,
  },
  {
    title: "Sjöutsikt",
    key: "lake_view",
    description: "Bostaden har utsikt över insjö eller vattendrag.",
    // hidden: true,
  },
  {
    title: "Havsutsikt",
    key: "sea_view",
    description: "Bostaden har utsikt över hav eller kustremsa.",
    // hidden: true,
  },
  {
    title: "Strandnära",
    key: "near_beach",
    description: "Bostaden har nära till strand.",
    // hidden: true,
  },
  {
    title: "Sekelskifte",
    key: "rustic",
    description: "Bostaden har välbevarade detaljer från sekelskiftet.",
    hidden: true,
  },
  {
    title: "Eldstad",
    key: "fireplace",
    description: "Bostaden har en eller flera öppna spisar.",
    // hidden: true,
  },
  {
    title: "Barnvänlig",
    key: "child_friendly_area",
    description: "Bostaden ligger i ett lugnt och barnvänligt område.",
    // hidden: true,
  },
  {
    title: "Golfklubb",
    key: "golf_course",
    description: "Bostaden ligger i närheten av en golfklubb.",
    // hidden: true,
  },
  {
    title: "Solpaneler",
    key: "solar_panels",
    description: "Bostaden genererar egen el med solpaneler.",
    // hidden: true,
  },
  {
    title: "Båtplats",
    key: "boat_berth",
    description: "Båtplats medföljer bostaden.",
    // hidden: true,
  },
  {
    title: "Bergvärme",
    key: "geothermal_heating",
    description: "Bostaden värms upp med energieffektiv värmepump.",
    hide_for_categories: ["apartment"],
    // hidden: true,
  },
  {
    title: "Luft-vatten värme",
    key: "airwater_heating",
    description: "Bostaden värms upp med energieffektiv värmepump.",
    hide_for_categories: ["apartment"],
    // hidden: true,
  },
  {
    title: "Laddstolpe",
    key: "ev_charging_post",
    description: "Bostaden har en eller flera laddstolpar för elbil.",
    // hidden: true,
  },
  {
    title: "Balkong",
    key: "balcony",
    description: "Bostaden har en balkong.",
  },
  {
    title: "Hiss",
    key: "elevator",
    description: "Åtkomst till bostaden via hiss.",
  },
  {
    title: "Bastu",
    key: "sauna",
    description: "Bostaden har en elektrisk eller vededlad bastu.",
    // hidden: true,
  },
  {
    title: "Bergsutsikt",
    key: "mountain_view",
    description: "Bostaden har ett högt läge med utsikt över berg.",
    // hidden: true,
  },
  {
    title: "Högt i tak",
    key: "high_ceiling",
    description: "Bostaden har rymd och högt i tak.",
    // hidden: true,
  },
  {
    title: "Pendlingsvänlig",
    key: "commute_friendly",
    description: "Bostaden erbjuder goda möjligheter till pendling.",
    // hidden: true,
  },
  {
    title: "Terrass",
    key: "terrace",
    description: "En eller flera terasser finns på tomten.",
    // hidden: true,
  },
  {
    title: "Jacuzzi",
    key: "jacuzzi",
    description: "Ett av badrummen har jacuzzi eller spabad.",
    // hidden: true,
  },
  {
    title: "Golvvärme",
    key: "floor_heating",
    description: "Bostaden har golvvärme i minst ett av rummen.",
  },
  {
    title: "Takterrass",
    key: "roof_terrace",
    description: "Bostaden har en takterass.",
  },
  // {
  //   title: 'Eftertraktat område',
  //   icon: PiShootingStar,
  //   key: 'reputed_area',
  //   description: 'Bostaden ligger i ett eftertraktat område.',
  // },
  {
    title: "Trädgård",
    key: "garden",
    description: "Bostaden har en trädgård.",
  },
  {
    title: "Vinkällare",
    key: "wine_cellar",
    description: "Bostaden har en vinkällare.",
  },
  {
    title: "Naturskönt område",
    key: "scenic_nature_area",
    description: "Bostaden ligger i ett lummigt, naturskönt område.",
  },
  {
    title: "Garage",
    key: "garage",
    description: "Bostaden har garage eller carport för bil.",
  },
  {
    title: "Badkar",
    key: "bath_tub",
    description: "Badkar finns i minst ett av badrummen.",
  },
  {
    title: "Klädkammare",
    key: "walk_in_closet",
    description: "Bostaden har minst en walk in closet.",
  },
  {
    title: "Fiber",
    key: "high_speed_internet",
    description: "Höghastighetsinternet finns i bostaden.",
  },
  {
    title: "Nyrenoverad",
    key: "renovated",
    description: "Delar av bostaden har nyligen renoverats.",
    hidden: true,
  },
  {
    title: "Uteplats",
    key: "patio",
    description: "Bostaden har minst en uteplats.",
  },
  {
    title: "Låg belåning",
    key: "low_loan_to_value_ratio",
    description: "Föreningen är har en låg belåningsgrad.",
    hide_for_categories: [
      "house",
      "cottage",
      "farm",
      "plot",
      "new_construction",
      "twinhouse",
      "terraced",
      "townhouse",
    ],
  },
  {
    title: "Låg avgift",
    key: "low_monthly_fee",
    description: "Föreningen har en låg månadsavgift.",
    hide_for_categories: [
      "house",
      "cottage",
      "farm",
      "plot",
      "new_construction",
      "twinhouse",
      "terraced",
      "townhouse",
    ],
  },
  {
    title: "Skuldfri förening",
    key: "debt_free_association",
    description: "Föreningen har betalat av sina skulder.",
    hide_for_categories: [
      "house",
      "cottage",
      "farm",
      "plot",
      "new_construction",
      "twinhouse",
      "terraced",
      "townhouse",
    ],
  },
  {
    title: "Juridisk person",
    key: "legal_person_allowed",
    description: "Juridisk person är tillåten för denna bostad.",
  },
  {
    title: "Parkering",
    key: "parking",
    description: "Parkeringsplats finns i anslutning till bostaden.",
  },
  {
    title: "Fruktträd",
    key: "fruit_trees",
    description: "Bostaden har en eller flera fruktträd.",
  },
  {
    title: "Friköpt mark",
    key: "freehold_plot",
    description: "Bostaden har en friköpt mark.",
    hide_for_categories: [
      "house",
      "cottage",
      "farm",
      "plot",
      "new_construction",
      "twinhouse",
      "terraced",
      "townhouse",
    ],
  },
];
